import {aisSiteLayerSettings} from '../settings/aisSiteLayerSettings';
import {aisReserveAssetData} from './aisReserveAssetLayer';
//import {aisSLayer} from './fetchMapLayers';

export var aisSLayer = null;

export function loadAisSiteLayer(gMap, apiLayer, guidFilter) {
    var deferred = new $.Deferred();
  
    var aisSiteLayer = new ngislib.DynamicAGOLayer({
        url: 'https://services1.arcgis.com/RYwXzrqre8JeYrSa/ArcGIS/rest/services/Test_AIS_DeclaredLand_External/FeatureServer/0',
        idField: 'AIS_Site',
        map: gMap,
        hasLOD: false,
        //userFilter: guidFilter,
        outFields: 'FID,AIS_Site'
    });

    aisSiteLayer.LayerId = aisSiteLayer.length + 1;

    aisSiteLayer.minZoom = apiLayer.MinLayerVisibility;
    aisSiteLayer.maxZoom = apiLayer.MaxLayerVisibility;
    aisSLayer = aisSiteLayer;
    aisSiteLayer.markers = [];
    aisSiteLayer.setStyle(aisSiteLayerSettings.inactiveAisSites.styles.defaultState);
   
    /* *** Add layer listeners *** */
    google.maps.event.addListener(aisSiteLayer, 'click', function (event) {
        var feat = event.feature;
        var map = aisSiteLayer.map;
        var featId = false;
        
        console.log("Click aisSite layer ");
        //console.log("aisReserveAssetData=" + aisReserveAssetData)
        if (typeof feat !== 'undefined' && feat !== null) {
            featId = feat.getId();
        }
  
        if (featId) {
            var aisSiteId = feat.getId();
            var aisSiteInfo=false;
            for(var s=0;s<aisReserveAssetData.length;s++){
                if(aisReserveAssetData[s].SiteName==aisSiteId){
                    aisSiteInfo = aisReserveAssetData[s];
                    break;
                }
            }
            if(aisSiteInfo){
                aisSiteLayer.ZoomFeature(feat);
            }           
  
        }
  
    });
  
    google.maps.event.addListener(
        aisSiteLayer,
        'status_changed',
        function () {
        //when parkLayer is panned, the park layer is refreshed, so does the data
        //so every feature that has been set is reset to initial state
        //updateFeatureStyles(parkLayer);
    });
  
    /* *** End add layer listeners *** */
  
    /* *** Add map listeners *** */
  
    google.maps.event.addListener(aisSiteLayer.map, 'zoom_changed',
        function (e) {
        var zoomLevel = this.getZoom();
        var map = this;
        var isVisible = (aisSiteLayer.minZoom <= zoomLevel) && (zoomLevel <= aisSiteLayer.maxZoom);
  
        aisSiteLayer.SetVisible(isVisible);       
    });
  
    /* *** End add map listeners *** */
  
    //return deferred.promise();
    deferred.promise();
    return aisSiteLayer;
  }
  
export function zoomToAisSite(siteName){
    try {
        if(aisSLayer==null)return;
        var feature=aisSLayer.getFeatureById(siteName);
        if(feature!=null)aisSLayer.ZoomFeature(feature);    
      }
      catch(err) {
        console.log(err.message);
      }
}
